import _ from 'lodash'
import moment from 'moment'

export interface IOption {
  Value: string
  Description: string
}

export interface IX12Helper {
  FileType: string
  Segment: string
  Element: number
  FriendlyName: string
  Semantics: string
  Options: IOption[]
  ToolTip: string
  DisplayAs?: string
  InputFormat: any
}

export class X12Codes {
  public static x12_837: IX12Helper[] = [
    {
      FileType: '837',
      Segment: 'ISA',
      Element: null,
      FriendlyName: 'Interchange Header (Outer Envelope)',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 1,
      FriendlyName: 'Authorization Information Qualifier',
      Options: [
        { Value: '00', Description: 'No Authorization Info Present' },
        { Value: '03', Description: 'Additional Data Identification' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 2,
      FriendlyName: 'Authorization Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 3,
      FriendlyName: 'Security Information Qualifier',
      Options: [
        { Value: '00', Description: 'No Security Info Present' },
        { Value: '01', Description: 'Password' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 4,
      FriendlyName: 'Security Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 5,
      FriendlyName: 'Interchange ID Qualifier',
      Options: [
        { Value: '01', Description: 'Duns (Dun & Bradstreet)' },
        { Value: '14', Description: 'Duns Plus Suffix' },
        { Value: '20', Description: 'Health Industry Number (HIN)' },
        { Value: '27', Description: 'Carrier Identification Number' },
        { Value: '28', Description: 'Fiscal Intermediary Identification Number.' },
        { Value: '29', Description: 'Medicare Provider and Supplier Identification Number' },
        { Value: '30', Description: 'U.S Federal Tax Identification Number' },
        {
          Value: '33',
          Description: 'National Association Of Insurance Commissioners Company Code (NAIC)'
        },
        { Value: 'ZZ', Description: 'Mutually Defined' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 6,
      FriendlyName: 'Interchange Sender ID',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 7,
      FriendlyName: 'Interchange ID Qualifier',
      Options: [
        { Value: '01', Description: 'Duns (Dun & Bradstreet)' },
        { Value: '14', Description: 'Duns Plus Suffix' },
        { Value: '20', Description: 'Health Industry Number (HIN)' },
        { Value: '27', Description: 'Carrier Identification Number' },
        { Value: '28', Description: 'Fiscal Intermediary Identification Number.' },
        { Value: '29', Description: 'Medicare Provider and Supplier Identification Number' },
        { Value: '30', Description: 'U.S Federal Tax Identification Number' },
        {
          Value: '33',
          Description: 'National Association Of Insurance Commissioners Company Code (NAIC)'
        },
        { Value: 'ZZ', Description: 'Mutually Defined' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 8,
      FriendlyName: 'Interchange Receiver ID',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 9,
      FriendlyName: 'Date',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYMMDD'
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 10,
      FriendlyName: 'Time',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 11,
      FriendlyName: 'Repetition Separator',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 12,
      FriendlyName: 'Interchange Control Version Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 13,
      FriendlyName: 'Interchange Control Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 14,
      FriendlyName: 'Acknowledgment Requested',
      Options: [
        { Value: '0', Description: 'No Acknowledgement Requested' },
        { Value: '1', Description: 'Interchange Acknowledgement Requested' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 15,
      FriendlyName: 'Usage Indicator',
      Options: [
        { Value: 'P', Description: 'Production Data' },
        { Value: 'T', Description: 'Test Data' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ISA',
      Element: 16,
      FriendlyName: 'Component Element Separator',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'IEA',
      Element: null,
      FriendlyName: 'Interchange Trailer',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'IEA',
      Element: 1,
      FriendlyName: 'Number of included functional groups',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'IEA',
      Element: 2,
      FriendlyName: 'Interchange Control Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GS',
      Element: null,
      FriendlyName: 'Functional Group Header (Inner Envelope)',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GS',
      Element: 1,
      FriendlyName: 'Functional ID Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GS',
      Element: 2,
      FriendlyName: "Sender's ID Code",
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GS',
      Element: 3,
      FriendlyName: "Receiver's ID Code",
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GS',
      Element: 4,
      FriendlyName: 'Date',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GS',
      Element: 5,
      FriendlyName: 'Time',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GS',
      Element: 6,
      FriendlyName: 'Group Control Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GS',
      Element: 7,
      FriendlyName: 'Responsible Agency Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GS',
      Element: 8,
      FriendlyName: 'Version/Release/Identifier Code',
      Options: [
        { Value: '005010X222A1', Description: 'Professional' },
        { Value: '005010X223A1', Description: 'Institutional' },
        { Value: '005010X224A1', Description: 'Dental' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GE',
      Element: null,
      FriendlyName: 'Functional Group Trailer',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GE',
      Element: 1,
      FriendlyName: 'Number of Transaction Sets',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'GE',
      Element: 2,
      FriendlyName: 'Group Control Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ST',
      Element: null,
      FriendlyName: 'Beginning of a transaction set',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ST',
      Element: 1,
      FriendlyName: 'Transaction Set Identifier Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ST',
      Element: 2,
      FriendlyName: 'Transaction Set Control Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'ST',
      Element: 3,
      FriendlyName: 'Implementation Convention Reference',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SE',
      Element: null,
      FriendlyName: 'End of a transaction set',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SE',
      Element: 1,
      FriendlyName: 'Number of Included Segments',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SE',
      Element: 2,
      FriendlyName: 'Transaction Set Control Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'BHT',
      Element: null,
      FriendlyName: 'Beginning of Hierarchical Transaction',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'BHT',
      Element: 1,
      FriendlyName: 'Hierarchical Structure Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'BHT',
      Element: 2,
      FriendlyName: 'Transaction Set Purpose Code',
      Options: [
        { Value: '00', Description: 'Original' },
        { Value: '18', Description: 'Reissue' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'BHT',
      Element: 3,
      FriendlyName: 'Reference Identification',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'BHT',
      Element: 4,
      FriendlyName: 'Date',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'BHT',
      Element: 5,
      FriendlyName: 'Time',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'BHT',
      Element: 6,
      FriendlyName: 'Transaction Type Code',
      Options: [
        { Value: '31', Description: 'Subrogation Demand' },
        { Value: 'CH', Description: 'Chargeable' },
        { Value: 'RP', Description: 'Reporting' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NM1',
      Element: null,
      FriendlyName: 'Name Record of various types',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NM1',
      Element: 1,
      FriendlyName: 'Entity Identifier Code',
      Options: [
        { Value: '40', Description: 'Receiver' },
        { Value: '41', Description: 'Submitter' },
        { Value: '77', Description: 'Service Facility Location' },
        { Value: '82', Description: 'Rendering Provider' },
        { Value: '85', Description: 'Billing Provider' },
        { Value: '87', Description: 'Pay-To Provider' },
        { Value: 'IL', Description: 'Subscriber (Insured)' },
        { Value: 'PR', Description: 'Payer' },
        { Value: 'QC', Description: 'Patient' },
        { Value: 'DN', Description: 'Referring Provider' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NM1',
      Element: 2,
      FriendlyName: 'Entity Type Qualifier',
      Options: [
        { Value: '1', Description: 'Person' },
        { Value: '2', Description: 'Non-Person Entity' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NM1',
      Element: 3,
      FriendlyName: 'Last Name or Organization Name',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NM1',
      Element: 4,
      FriendlyName: 'First Name',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NM1',
      Element: 5,
      FriendlyName: 'Middle Name',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NM1',
      Element: 6,
      FriendlyName: 'Name Prefix',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NM1',
      Element: 7,
      FriendlyName: 'Name Suffix',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NM1',
      Element: 8,
      FriendlyName: 'Identification Code Qualifier',
      Options: [
        { Value: '46', Description: 'ETIN Established by trading partner agreement' },
        { Value: 'MI', Description: 'Insured Policy Number' },
        { Value: 'PI', Description: 'Payer ID' },
        { Value: 'XX', Description: 'NPI' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NM1',
      Element: 9,
      FriendlyName: 'Identification Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PER',
      Element: null,
      FriendlyName: 'Contact Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PER',
      Element: 1,
      FriendlyName: 'Contact Function Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PER',
      Element: 2,
      FriendlyName: 'Name',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PER',
      Element: 3,
      FriendlyName: 'Communication Number Qualifier',
      Options: [
        { Value: 'ED', Description: 'Electronic data interchange Access Number.' },
        { Value: 'EM', Description: 'Electronic Mail' },
        { Value: 'EX', Description: 'Telephone Extension' },
        { Value: 'FX', Description: 'Facsimile' },
        { Value: 'TE', Description: 'Telephone' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PER',
      Element: 4,
      FriendlyName: 'Communication Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PER',
      Element: 5,
      FriendlyName: 'Communication Number Qualifier 2',
      Options: [
        { Value: 'ED', Description: 'Electronic data interchange Access Number.' },
        { Value: 'EM', Description: 'Electronic Mail' },
        { Value: 'EX', Description: 'Telephone Extension' },
        { Value: 'FX', Description: 'Facsimile' },
        { Value: 'TE', Description: 'Telephone' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PER',
      Element: 6,
      FriendlyName: 'Communication Number 2',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PER',
      Element: 7,
      FriendlyName: 'Communication Number Qualifier 3',
      Options: [
        { Value: 'ED', Description: 'Electronic data interchange Access Number.' },
        { Value: 'EM', Description: 'Electronic Mail' },
        { Value: 'EX', Description: 'Telephone Extension' },
        { Value: 'FX', Description: 'Facsimile' },
        { Value: 'TE', Description: 'Telephone' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PER',
      Element: 8,
      FriendlyName: 'Communication Number 3',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HL',
      Element: null,
      FriendlyName: 'Hierarchical Level',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HL',
      Element: 1,
      FriendlyName: 'Hierarchical ID Number',
      Options: [
        { Value: '1', Description: 'Billing Provider Level' },
        { Value: '2', Description: 'Subscriber Level' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HL',
      Element: 2,
      FriendlyName: 'Hierarchical Parent ID Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HL',
      Element: 3,
      FriendlyName: 'Hierarchical Level Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HL',
      Element: 4,
      FriendlyName: 'Hierarchical Child Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'N3',
      Element: null,
      FriendlyName: 'Address',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'N3',
      Element: 1,
      FriendlyName: 'Address Line 1',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'N3',
      Element: 2,
      FriendlyName: 'Address Line 2',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'N4',
      Element: null,
      FriendlyName: 'Address City/State/Zip',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'N4',
      Element: 1,
      FriendlyName: 'City Name',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'N4',
      Element: 2,
      FriendlyName: 'State or Province Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'N4',
      Element: 3,
      FriendlyName: 'Postal Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SBR',
      Element: null,
      FriendlyName: 'Subscriber Information (Follows with HL*2)',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SBR',
      Element: 1,
      FriendlyName: 'Payer Responsibility Code',
      Options: [
        { Value: 'P', Description: 'Primary' },
        { Value: 'S', Description: 'Secondary' },
        { Value: 'T', Description: 'Tertiary' },
        { Value: 'A', Description: 'Code for the 4th Insurance' },
        { Value: 'B', Description: 'Code for the 5th Insurance' },
        { Value: 'C', Description: 'Code for the 6th Insurance' },
        { Value: 'D', Description: 'Code for the 7th Insurance' },
        { Value: 'E', Description: 'Code for the 8th Insurance' },
        { Value: 'F', Description: 'Code for the 9th Insurance' },
        { Value: 'G', Description: 'Code for the 10th Insurance' },
        { Value: 'H', Description: 'Code for the 11th Insurance' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SBR',
      Element: 2,
      FriendlyName: 'Individual Relationship Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SBR',
      Element: 3,
      FriendlyName: 'Reference Identification',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SBR',
      Element: 4,
      FriendlyName: 'Name',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SBR',
      Element: 5,
      FriendlyName: 'Insurance Type Code',
      Options: [
        {
          Value: '12',
          Description:
            'Medicare Secondary Working Aged Beneficiary or Spouse with Employer Group Health Plan'
        },
        { Value: '13', Description: 'Medicare Secondary End Stage Renal Disease' },
        {
          Value: '14',
          Description: 'Medicare Secondary , No Fault Insurance including Auto is Primary'
        },
        { Value: '15', Description: 'Medicare Secondary Worker’s Compensation' },
        {
          Value: '16',
          Description: 'Medicare Secondary Public Health Service (PHS) or other Federal Agency'
        },
        { Value: '41', Description: 'Medicare Secondary Black Lung' },
        { Value: '42', Description: 'Medicare Secondary Veteran’s Administration' },
        { Value: '43', Description: 'Medicare Secondary Veteran’s Administration' },
        { Value: '47', Description: 'Medicare Secondary, Other Liability Insurance is Primary' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SBR',
      Element: 6,
      FriendlyName: 'Coordination Of Benefit Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SBR',
      Element: 7,
      FriendlyName: 'Yes/No Condition',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SBR',
      Element: 8,
      FriendlyName: 'Employment Status Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SBR',
      Element: 9,
      FriendlyName: 'Claim Filing Indicator Code',
      Options: [
        { Value: '11', Description: 'Other Non-Federal Programs' },
        { Value: '12', Description: 'Preferred Provider Organizations' },
        { Value: '13', Description: 'Point of Service' },
        { Value: '14', Description: 'Exclusive Provider Organization' },
        { Value: '15', Description: 'Indemnity Insurance' },
        { Value: '16', Description: 'Health Maintenance Organization (HMO) Medicare Risk' },
        { Value: '17', Description: 'Dental Maintenance Organization' },
        { Value: 'AM', Description: 'Automobile Medical' },
        { Value: 'BL', Description: 'Blue Cross/Blue Shield' },
        { Value: 'CH', Description: 'Champus' },
        { Value: 'CI', Description: 'Commercial Insurance Co' },
        { Value: 'DS', Description: 'Disability' },
        { Value: 'HM', Description: 'Health Maintenance Organization' },
        { Value: 'LM', Description: 'Liability Medical' },
        { Value: 'MB', Description: 'Medicare Part B' },
        { Value: 'MC', Description: 'Medicaid' },
        { Value: 'MA', Description: 'Medicare Part A' },
        { Value: 'OF', Description: 'Other Federal Program' },
        { Value: 'TV', Description: 'Title V' },
        { Value: 'VA', Description: 'Veteran Administration Plan' },
        { Value: 'WC', Description: 'Worker’s Compensation Health Claim' },
        { Value: 'FI', Description: 'Federal Employees Program' },
        { Value: 'ZZ', Description: 'Mutually Defined' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'DMG',
      Element: null,
      FriendlyName: 'Subscriber Demographics (Follows with NM1*IL)',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'DMG',
      Element: 1,
      FriendlyName: 'Date time Period Format Qualifier',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'DMG',
      Element: 2,
      FriendlyName: 'Date time Period',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'DMG',
      Element: 3,
      FriendlyName: 'Gender Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: null,
      FriendlyName: 'Claim Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: 1,
      FriendlyName: 'Claim Submitter Identifier',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: 2,
      FriendlyName: 'Monetary Amount (Total Charges)',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: 3,
      FriendlyName: 'Claim Filling Indicator',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: 4,
      FriendlyName: 'Non Institutional Claim Type',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: 5,
      FriendlyName: 'Facility Code Value (Place of service code)',
      Options: [{ Value: 'Facility Code Qualifier (B) : Claim Frequency Type Code' }]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: 6,
      FriendlyName: 'Yes/No Provider Signature on File',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: 7,
      FriendlyName: 'Provider Accept Assignment Code',
      Options: [
        { Value: 'A', Description: 'Assigned' },
        { Value: 'B', Description: 'Assignment Accepted on Clinical Lab Services Only' },
        { Value: 'C', Description: 'Not Assigned' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: 8,
      FriendlyName: 'Yes/No Assignments of Benefit',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: 9,
      FriendlyName: 'Yes/No Release of Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CLM',
      Element: 10,
      FriendlyName: 'Patient signature source code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'REF',
      Element: null,
      FriendlyName: 'Reference',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'REF',
      Element: 1,
      FriendlyName: 'Reference Identification Qualifier',
      Options: [
        { Value: '9F', Description: 'Referral Number' },
        { Value: '0B', Description: 'State License Number' },
        { Value: '1G', Description: 'Provider UPIN Number' },
        { Value: 'EI', Description: 'Tax Identification Number' },
        { Value: 'G1', Description: 'Prior Authorization' },
        { Value: 'G2', Description: 'Provider Commercial Number' },
        { Value: 'D9', Description: 'Value Added Network Trace Number' },
        { Value: 'X4', Description: 'Clinical Laboratory Improvement Amendment Number (CLIA)' },
        { Value: 'LU', Description: 'Location Number' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'REF',
      Element: 2,
      FriendlyName: 'Reference Identification',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: null,
      FriendlyName: 'Health care diagnosis code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 1,
      FriendlyName: 'Code List Qualifier Code',
      Options: [
        { Value: 'BK', Description: 'ICD9 Principal Diagnosis' },
        { Value: 'BF', Description: 'ICD9 Diagnosis' },
        { Value: 'ABK', Description: 'ICD10 Principal Diagnosis' },
        { Value: 'ABF', Description: 'ICD10 Diagnosis' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 2,
      FriendlyName: 'Industry Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 3,
      FriendlyName: 'Code List Qualifier Code 2',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 4,
      FriendlyName: 'Industry Code 2',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 5,
      FriendlyName: 'Code List Qualifier Code 3',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 6,
      FriendlyName: 'Industry Code 3',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 7,
      FriendlyName: 'Code List Qualifier Code 4',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 8,
      FriendlyName: 'Industry Code 4',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 9,
      FriendlyName: 'Code List Qualifier Code 5',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 10,
      FriendlyName: 'Industry Code 5',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 11,
      FriendlyName: 'Code List Qualifier Code 6',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 12,
      FriendlyName: 'Industry Code 6',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 13,
      FriendlyName: 'Code List Qualifier Code 7',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 14,
      FriendlyName: 'Industry Code 7',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 15,
      FriendlyName: 'Code List Qualifier Code 8',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 16,
      FriendlyName: 'Industry Code 8',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 17,
      FriendlyName: 'Code List Qualifier Code 9',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 18,
      FriendlyName: 'Industry Code 9',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 19,
      FriendlyName: 'Code List Qualifier Code 10',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 20,
      FriendlyName: 'Industry Code 10',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 21,
      FriendlyName: 'Code List Qualifier Code 11',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 22,
      FriendlyName: 'Industry Code 11',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 23,
      FriendlyName: 'Code List Qualifier Code 12',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HI',
      Element: 24,
      FriendlyName: 'Industry Code 12',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'LX',
      Element: null,
      FriendlyName: 'Service Line',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'LX',
      Element: 1,
      FriendlyName: 'Assigned Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: null,
      FriendlyName: 'Professional Service',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 1,
      FriendlyName: 'Product/Service',
      Options: [
        { Value: 'ID Qualifier' },
        { Value: 'Product/Service ID' },
        { Value: 'Procedure Modifier' },
        { Value: 'Procedure Modifier 2' },
        { Value: 'Procedure Modifier 3' },
        { Value: 'Procedure Modifier 4' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 2,
      FriendlyName: 'Monetary Amount',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 3,
      FriendlyName: 'Unit',
      Options: [
        { Value: 'UN', Description: 'Units' },
        { Value: 'MJ', Description: 'Minutes' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 4,
      FriendlyName: 'Quantity',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 5,
      FriendlyName: 'Facility Code Value',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 6,
      FriendlyName: 'Service Type Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 7,
      FriendlyName: 'Composite Diagnosis Code Pointer',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 8,
      FriendlyName: 'Yes/No Emergency Indicator',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 9,
      FriendlyName: 'Multiple Procedure Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 10,
      FriendlyName: 'Yes/No EPSDT Indicator',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 11,
      FriendlyName: 'Yes/No Family Planning Indicator',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 12,
      FriendlyName: 'Review Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 13,
      FriendlyName: 'National or Local Assigned Review Value',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV1',
      Element: 14,
      FriendlyName: 'Copay Status Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV2',
      Element: 1,
      FriendlyName: 'Revenue Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV2',
      Element: 2,
      FriendlyName: 'Procedure Code and Modifier',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV2',
      Element: 3,
      FriendlyName: 'Line Billed Amount',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV2',
      Element: 4,
      FriendlyName: 'Basis for Measurement',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SV2',
      Element: 5,
      FriendlyName: 'Unit(s)',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'DTP',
      Element: null,
      FriendlyName: 'Date of Onset of current illness/symptom',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'DTP',
      Element: 1,
      FriendlyName: 'Date/Time Qualifier',
      Options: [
        { Value: '431', Description: 'Onset' },
        { Value: '454', Description: 'Initial Treatment' },
        { Value: '304', Description: 'Last Seen' },
        { Value: '453', Description: 'Acute Manifestation' },
        { Value: '439', Description: 'Accident' },
        { Value: '484', Description: 'Last Menstrual' },
        { Value: '455', Description: 'Last X-Ray' },
        { Value: '471', Description: 'Hearing and Vision Prescription' },
        { Value: '472', Description: 'Service' },
        { Value: '297', Description: 'Last Worked' },
        { Value: '573', Description: 'Adjudication' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'DTP',
      Element: 2,
      FriendlyName: 'Date Time Period Format Qualifier',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'DTP',
      Element: 3,
      FriendlyName: 'Service Date',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'K3',
      Element: null,
      FriendlyName: 'Claim Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'K3',
      Element: 1,
      FriendlyName: 'Fixed format Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'AMT',
      Element: null,
      FriendlyName: 'Payer Paid Amount',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'AMT',
      Element: 1,
      FriendlyName: 'Amount Qualifier Code',
      Options: [{ Value: 'D', Description: 'Payer Amount Paid' }]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'AMT',
      Element: 2,
      FriendlyName: 'Monetary Amount',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'OI',
      Element: null,
      FriendlyName: 'Other Insurance Coverage Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'OI',
      Element: 1,
      FriendlyName: 'Claim Filling Indicator Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'OI',
      Element: 2,
      FriendlyName: 'Claim Submission Reason Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'OI',
      Element: 3,
      FriendlyName: 'Yes/No Assignment of BenefitDTPs',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'OI',
      Element: 4,
      FriendlyName: 'Patient Signature Source Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'OI',
      Element: 5,
      FriendlyName: 'Provider Agreement Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'OI',
      Element: 6,
      FriendlyName: 'Yes/No Release of Information Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SVD',
      Element: null,
      FriendlyName: 'Line Adjudication Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SVD',
      Element: 1,
      FriendlyName: 'Identification Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SVD',
      Element: 2,
      FriendlyName: 'Monetary Amount',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SVD',
      Element: 3,
      FriendlyName: 'Product/Service ID Qualifier',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SVD',
      Element: 4,
      FriendlyName: 'Product/Service ID',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SVD',
      Element: 5,
      FriendlyName: 'Procedure Modifier : 2 : 3 : 4 : Description',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SVD',
      Element: 6,
      FriendlyName: 'Description',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'SVD',
      Element: 7,
      FriendlyName: 'Quantity',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CAS',
      Element: null,
      FriendlyName: 'Line Adjustment',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CAS',
      Element: 1,
      FriendlyName: 'Claim Adjustment Group Code',
      Options: [{ Value: 'PR' }, { Value: 'CO' }]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CAS',
      Element: 2,
      FriendlyName: 'Claim Adjustment Reason Code',
      Options: [
        { Value: '1', Description: 'Deductible' },
        { Value: '2', Description: 'Coinsurance' },
        { Value: '3', Description: 'Copay' },
        { Value: '45', Description: 'Insurance Adjustments' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'CAS',
      Element: 3,
      FriendlyName: 'Monetary Amount',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: null,
      FriendlyName: 'Claim Pricing/Repricing Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 1,
      FriendlyName: 'Pricing Methodology',
      Options: [
        { Value: '00', Description: 'Zero Pricing (Not Covered Under Contract)' },
        { Value: '01', Description: 'Priced as Billed at 100%' },
        { Value: '02', Description: 'Priced at the Standard Fee Schedule' },
        { Value: '03', Description: 'Priced at a Contractual Percentage' },
        { Value: '04', Description: 'Bundled Pricing' },
        { Value: '05', Description: 'Peer Review Pricing' },
        { Value: '07', Description: 'Flat Rate Pricing' },
        { Value: '08', Description: 'Combination Pricing' },
        { Value: '09', Description: 'Maternity Pricing' },
        { Value: '10', Description: 'Other Pricing' },
        { Value: '11', Description: 'Lower of Cost' },
        { Value: '12', Description: 'Ratio of Cost' },
        { Value: '13', Description: 'Cost Reimbursed' },
        { Value: '14', Description: 'Adjustment Pricing' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 2,
      FriendlyName: 'Allowed Amount',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 3,
      FriendlyName: 'Savings Amount',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 4,
      FriendlyName: 'Reference Identification',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 5,
      FriendlyName: 'Rate',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 6,
      FriendlyName: 'Reference Identification',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 7,
      FriendlyName: 'Approved DRG Amount',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 8,
      FriendlyName: 'Product/Service ID',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 9,
      FriendlyName: 'Product/Service ID Qualifier',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 10,
      FriendlyName: 'Product/Service ID',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 11,
      FriendlyName: 'Unit or Basis for Measurement Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 12,
      FriendlyName: 'Quantity',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 13,
      FriendlyName: 'Reject Reason Code',
      Options: [
        { Value: 'T1', Description: 'Cannot Identify Provider as TPO Participant' },
        { Value: 'T2', Description: 'Cannot Identify Payer as TPO Participant' },
        { Value: 'T3', Description: 'Cannot Identify Insured as TPO Participant' },
        { Value: 'T4', Description: 'Payer Name or Identifier Missing' },
        { Value: 'T5', Description: 'Certification Information Missing' },
        { Value: 'T6', Description: 'Claim does not contain enough information for re-pricing' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 14,
      FriendlyName: 'Policy Compliance Code',
      Options: [
        { Value: '1', Description: 'Procedure Followed (Compliance)' },
        { Value: '2', Description: 'Not Followed - Call Not Made' },
        { Value: '3', Description: 'Not Medically Necessary' },
        { Value: '4', Description: 'Not Followed Other' },
        { Value: '5', Description: 'Emergency Admit to Non-Network Hospital' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'HCP',
      Element: 15,
      FriendlyName: 'Exception Code',
      Options: [
        { Value: '1', Description: 'Non-Network Professional Provider in Network Hospital' },
        { Value: '2', Description: 'Emergency Care' },
        { Value: '3', Description: 'Services or Specialist not in Network' },
        { Value: '4', Description: 'Out-of-Service Area' },
        { Value: '5', Description: 'State Mandates' },
        { Value: '6', Description: 'Other' }
      ]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PRV',
      Element: null,
      FriendlyName: 'Billing/Pay-to Provider Specialty',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PRV',
      Element: 1,
      FriendlyName: 'Provider Code',
      Options: [{ Value: 'BI', Description: 'Billing' }]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PRV',
      Element: 2,
      FriendlyName: 'Reference Identification Qualifier',
      Options: [{ Value: 'PXC', Description: 'Health Care Provider Taxonomy Code' }]
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PRV',
      Element: 3,
      FriendlyName: 'Reference Identification',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PRV',
      Element: 4,
      FriendlyName: 'State or Province Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PRV',
      Element: 5,
      FriendlyName: 'Provider Specialty Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PRV',
      Element: 6,
      FriendlyName: 'Provider Organization Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PAT',
      Element: 1,
      FriendlyName: 'Individual Relationship with Subscriber',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PAT',
      Element: 2,
      FriendlyName: 'Patient Location Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PAT',
      Element: 3,
      FriendlyName: 'Employment Status Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PAT',
      Element: 4,
      FriendlyName: 'Student Status Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PAT',
      Element: 5,
      FriendlyName: 'Date Time Period Format Qualifier',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PAT',
      Element: 6,
      FriendlyName: 'Patient Death Date',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PAT',
      Element: 7,
      FriendlyName: 'Unit or Basis for Measurement Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PAT',
      Element: 8,
      FriendlyName: 'Patient Weight',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'PAT',
      Element: 9,
      FriendlyName: 'Pregnancy Indicator',
      Options: null
    } as IX12Helper,
    {
      FileType: '837',
      Segment: 'NTE',
      Element: 1,
      FriendlyName: 'Note',
      Options: null
    } as IX12Helper
  ]

  public static x12_835: IX12Helper[] = [
    {
      FileType: '835',
      Segment: 'ISA',
      Element: null,
      FriendlyName: 'Interchange Header (Outer Envelope)',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 1,
      FriendlyName: 'Authorization Information Qualifier',
      Options: [
        { Value: '00', Description: 'No Authorization Info Present' },
        { Value: '03', Description: 'Additional Data Identification' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 2,
      FriendlyName: 'Authorization Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 3,
      FriendlyName: 'Security Information Qualifier',
      Options: [
        { Value: '00', Description: 'No Security Info Present' },
        { Value: '01', Description: 'Password' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 4,
      FriendlyName: 'Security Information',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 5,
      FriendlyName: 'Interchange ID Qualifier',
      Options: [
        { Value: '01', Description: 'Duns (Dun & Bradstreet)' },
        { Value: '14', Description: 'Duns Plus Suffix' },
        { Value: '20', Description: 'Health Industry Number (HIN)' },
        { Value: '27', Description: 'Carrier Identification Number' },
        { Value: '28', Description: 'Fiscal Intermediary Identification Number.' },
        { Value: '29', Description: 'Medicare Provider and Supplier Identification Number' },
        { Value: '30', Description: 'U.S Federal Tax Identification Number' },
        {
          Value: '33',
          Description: 'National Association Of Insurance Commissioners Company Code (NAIC)'
        },
        { Value: 'ZZ', Description: 'Mutually Defined' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 6,
      FriendlyName: 'Interchange Sender ID',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 7,
      FriendlyName: 'Interchange ID Qualifier',
      Options: [
        { Value: '01', Description: 'Duns (Dun & Bradstreet)' },
        { Value: '14', Description: 'Duns Plus Suffix' },
        { Value: '20', Description: 'Health Industry Number (HIN)' },
        { Value: '27', Description: 'Carrier Identification Number' },
        { Value: '28', Description: 'Fiscal Intermediary Identification Number.' },
        { Value: '29', Description: 'Medicare Provider and Supplier Identification Number' },
        { Value: '30', Description: 'U.S Federal Tax Identification Number' },
        {
          Value: '33',
          Description: 'National Association Of Insurance Commissioners Company Code (NAIC)'
        },
        { Value: 'ZZ', Description: 'Mutually Defined' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 8,
      FriendlyName: 'Interchange Receiver ID',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 9,
      FriendlyName: 'Date',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYMMDD'
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 10,
      FriendlyName: 'Time',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 11,
      FriendlyName: 'Repetition Separator',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 12,
      FriendlyName: 'Interchange Control Version Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 13,
      FriendlyName: 'Interchange Control Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 14,
      FriendlyName: 'Acknowledgment Requested',
      Options: [
        { Value: '0', Description: 'No Acknowledgement Requested' },
        { Value: '1', Description: 'Interchange Acknowledgement Requested' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 15,
      FriendlyName: 'Usage Indicator',
      Options: [
        { Value: 'P', Description: 'Production Data' },
        { Value: 'T', Description: 'Test Data' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ISA',
      Element: 16,
      FriendlyName: 'Component Element Separator',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'IEA',
      Element: null,
      FriendlyName: 'Interchange Trailer',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'IEA',
      Element: 1,
      FriendlyName: 'Number of included functional groups',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'IEA',
      Element: 2,
      FriendlyName: 'Interchange Control Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GS',
      Element: null,
      FriendlyName: 'Functional Group Header (Inner Envelope)',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GS',
      Element: 1,
      FriendlyName: 'Functional ID Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GS',
      Element: 2,
      FriendlyName: "Sender's ID Code",
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GS',
      Element: 3,
      FriendlyName: "Receiver's ID Code",
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GS',
      Element: 4,
      FriendlyName: 'Date',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GS',
      Element: 5,
      FriendlyName: 'Time',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GS',
      Element: 6,
      FriendlyName: 'Group Control Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GS',
      Element: 7,
      FriendlyName: 'Responsible Agency Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GS',
      Element: 8,
      FriendlyName: 'Version/Release/Identifier Code',
      Options: [
        { Value: '005010X222A1', Description: 'Professional' },
        { Value: '005010X223A1', Description: 'Institutional' },
        { Value: '005010X224A1', Description: 'Dental' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GE',
      Element: null,
      FriendlyName: 'Functional Group Trailer',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GE',
      Element: 1,
      FriendlyName: 'Number of Transaction Sets',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'GE',
      Element: 2,
      FriendlyName: 'Group Control Number',
      Options: null
    } as IX12Helper,

    {
      FileType: '835',
      Segment: 'ST',
      Element: null,
      FriendlyName: 'Transaction Set Header',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ST',
      Element: 1,
      FriendlyName: 'Transaction Set Identifier Code',
      Semantics:
        'Used by the transaltion routines of the interchange partners to select the appropriate transaction set definition',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ST',
      Element: 2,
      FriendlyName: 'Transaction Set Control Number',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'ST',
      Element: 3,
      FriendlyName: 'Implementation Convention Reference',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: null,
      FriendlyName: 'Financial Information',
      Semantics: '',
      Options: [
        { Value: 'C', Description: 'Payment Accompanies Remittance Advice' },
        { Value: 'D', Description: 'Make Payment Only' },
        { Value: 'H', Description: 'Notification Only' },
        { Value: 'I', Description: 'Remittance Information Only' },
        { Value: 'P', Description: 'Prenotification of Future Transfers' },
        { Value: 'U', Description: 'Split Payment and Remittance' },
        { Value: 'X', Description: "Handling Party's Option to Split Payment and Remittance" }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 1,
      FriendlyName: 'Transaction Handling Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 2,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Payment Amount',
      Options: [
        { Value: 'C', Description: 'Credit' },
        { Value: 'D', Description: 'Debit' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 3,
      FriendlyName: 'Credit/Debit Flag Code',
      Semantics: '',
      Options: [
        { Value: 'ACH', Description: 'Automated Clearing House' },
        { Value: 'BOP', Description: 'Financial Institution Option' },
        { Value: 'CHK', Description: 'Check' },
        { Value: 'FWT', Description: 'Federal Reserve Funds/Wire Transfer - Nonrepetitive' },
        { Value: 'NON', Description: 'Non-Payment Data' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 4,
      FriendlyName: 'Payment Method Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 5,
      FriendlyName: 'Payment Format Code',
      Semantics: '',
      Options: [
        { Value: '1', Description: 'ABA Transit Routing Number Including Check Digits (9 digits)' },
        { Value: '4', Description: 'Canadian Bank Branch and Institution Number' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 6,
      FriendlyName: '(DFI) ID Number Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 7,
      FriendlyName: '(DFI) Identification Number',
      Semantics: '',
      Options: [
        { Value: 'DA', Description: 'Demand Deposit' },
        { Value: 'SG', Description: 'Savings' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 8,
      FriendlyName: 'Account Number Qualifier',
      Semantics: 'Code identifying the type of bank account or other financial asset.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 9,
      FriendlyName: 'Account Number',
      Semantics: 'Account of the company originating the payment.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 10,
      FriendlyName: 'Originating Company Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 11,
      FriendlyName: 'Originating Company Supplemental Code',
      Semantics: '',
      Options: [
        { Value: '1', Description: 'ABA Transit Routing Number Including Check Digits (9 digits)' },
        { Value: '4', Description: 'Canadian Bank Branch and Institution Number' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 12,
      FriendlyName: '(DFI) ID Number Qualifier',
      Semantics: 'Receiving depository financial institution.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 13,
      FriendlyName: '(DFI) Identification Number',
      Semantics: 'Receiving depository financial institution.',
      Options: [
        { Value: 'DA', Description: 'Demand Deposit' },
        { Value: 'SG', Description: 'Savings' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 14,
      FriendlyName: 'Account Number Qualifier',
      Semantics: 'Code identifying the type of b ank account or other financial asset.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 15,
      FriendlyName: 'Account Number',
      Semantics:
        'Account number of the receiving company to be debited or credited with the payment order.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 16,
      FriendlyName: 'Date',
      Semantics:
        'Date the originating company intends for the transaction to be settled. (Payment Effective Date)',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 17,
      FriendlyName: 'Business Function Code',
      Semantics: '',
      Options: [
        { Value: '1', Description: 'ABA Transit Routing Number Including Check Digits (9 digits)' },
        { Value: '4', Description: 'Canadian Bank Branch and Institution Number' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 18,
      FriendlyName: '(DFI) ID Number Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 19,
      FriendlyName: '(DFI) Identification Number',
      Semantics: '',
      Options: [
        { Value: 'DA', Description: 'Demand Deposit' },
        { Value: 'SG', Description: 'Savings' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 20,
      FriendlyName: 'Account Number Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'BPR',
      Element: 21,
      FriendlyName: 'Account Number',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TRN',
      Element: null,
      FriendlyName: 'Reassociation Trace Number',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TRN',
      Element: 1,
      FriendlyName: 'Trace Type Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TRN',
      Element: 2,
      FriendlyName: 'Reference Identification',
      Semantics: 'Unique id for the transaction',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TRN',
      Element: 3,
      FriendlyName: 'Originating Company Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TRN',
      Element: 4,
      FriendlyName: 'Reference Identification',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: null,
      FriendlyName: 'Foreign Currency Information',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 1,
      FriendlyName: 'Entity Identifier Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 2,
      FriendlyName: 'Currency Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 3,
      FriendlyName: 'Exchange Rate',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 4,
      FriendlyName: 'Entity Identifier Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 5,
      FriendlyName: 'Currency Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 6,
      FriendlyName: 'Currency Markey/Exchange Code',
      Semantics: '',
      Options: [
        { Value: '232', Description: 'Claim Statement Period Start' },
        { Value: '233', Description: 'Claim Statement Period End' },
        { Value: '036', Description: 'Expiration' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 7,
      FriendlyName: 'Date/Time Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 8,
      FriendlyName: 'Date',
      Semantics: '',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 9,
      FriendlyName: 'Time',
      Semantics: '',
      Options: [
        { Value: '232', Description: 'Claim Statement Period Start' },
        { Value: '233', Description: 'Claim Statement Period End' },
        { Value: '036', Description: 'Expiration' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 10,
      FriendlyName: 'Date/Time Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 11,
      FriendlyName: 'Date',
      Semantics: '',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 12,
      FriendlyName: 'Time',
      Semantics: '',
      Options: [
        { Value: '232', Description: 'Claim Statement Period Start' },
        { Value: '233', Description: 'Claim Statement Period End' },
        { Value: '036', Description: 'Expiration' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 13,
      FriendlyName: 'Date/Time Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 14,
      FriendlyName: 'Date',
      Semantics: '',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 15,
      FriendlyName: 'Time',
      Semantics: '',
      Options: [
        { Value: '232', Description: 'Claim Statement Period Start' },
        { Value: '233', Description: 'Claim Statement Period End' },
        { Value: '036', Description: 'Expiration' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 16,
      FriendlyName: 'Date/Time Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 17,
      FriendlyName: 'Date',
      Semantics: '',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 18,
      FriendlyName: 'Time',
      Semantics: '',
      Options: [
        { Value: '232', Description: 'Claim Statement Period Start' },
        { Value: '233', Description: 'Claim Statement Period End' },
        { Value: '036', Description: 'Expiration' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 19,
      FriendlyName: 'Date/Time Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 20,
      FriendlyName: 'Date',
      Semantics: '',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CUR',
      Element: 21,
      FriendlyName: 'Time',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'REF',
      Element: null,
      FriendlyName: 'Reference Information',
      Semantics: '',
      Options: [
        { Value: '28', Description: 'Employee Identification Number' },
        { Value: '0B', Description: 'State License Number' },
        { Value: '1A', Description: 'Blue Cross Provider Number' },
        { Value: '1B', Description: 'Blue Shield Provider Number' },
        { Value: '1C', Description: 'Medicare Provider Number' },
        { Value: '1D', Description: 'Medicaid Provider Number' },
        { Value: '1G', Description: 'Provider UPIN' },
        { Value: '1H', Description: 'CHAMPUS Identification Number' },
        { Value: '1J', Description: 'Facility ID' },
        { Value: '1L', Description: 'Group or Policy Number' },
        { Value: '1W', Description: 'Member Identification Number' },
        { Value: '2U', Description: 'Payer Identification Number' },
        { Value: '6P', Description: 'Group Number' },
        { Value: '9A', Description: 'Repriced Claim Reference' },
        { Value: '9C', Description: 'Adjusted Repriced Claim Reference Number' },
        { Value: 'BB', Description: 'Authorization Number' },
        { Value: 'CE', Description: 'Class Of Contract Code' },
        {
          Value: 'D3',
          Description: 'National Council for Prescription Drug Programs Pharmacy Number'
        },
        { Value: 'EA', Description: 'Medical Record Identification Number' },
        { Value: 'EO', Description: 'Submitter Identification Number' },
        { Value: 'F8', Description: 'Original Reference Number' },
        { Value: 'G1', Description: 'Prior Authorization Number' },
        { Value: 'G2', Description: 'Provider Commercial Number' },
        { Value: 'G3', Description: 'Predetermination Of Benefits Identification Number' },
        { Value: 'HI', Description: 'Health Industry Number (HIN)' },
        { Value: 'IG', Description: 'Insurance Policy Number' },
        { Value: 'LU', Description: 'Location Number' },
        { Value: 'NF', Description: 'National Association of Insurance Commissioners (NAIC) Code' },
        { Value: 'PQ', Description: 'Payee Identification' },
        { Value: 'SY', Description: 'Social Security Number' },
        { Value: 'TJ', Description: 'Federal Taxpayers Identification Number' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'REF',
      Element: 1,
      FriendlyName: 'Reference Identification Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'REF',
      Element: 2,
      FriendlyName: 'Reference Identification',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'REF',
      Element: 3,
      FriendlyName: 'Description',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'REF',
      Element: 4,
      FriendlyName: 'Reference Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'DTM',
      Element: null,
      FriendlyName: 'Date',
      Semantics: '',
      Options: [
        { Value: '232', Description: 'Claim Statement Period Start' },
        { Value: '233', Description: 'Claim Statement Period End' },
        { Value: '036', Description: 'Expiration' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'DTM',
      Element: 1,
      FriendlyName: 'Date/Time Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'DTM',
      Element: 2,
      FriendlyName: 'Date',
      Semantics: '',
      Options: null,
      DisplayAs: 'date',
      InputFormat: 'YYYYMMDD'
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'DTM',
      Element: 3,
      FriendlyName: 'Time',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'DTM',
      Element: 4,
      FriendlyName: 'Time Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'DTM',
      Element: 5,
      FriendlyName: 'Date Time Period Format Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'DTM',
      Element: 6,
      FriendlyName: 'Date Time Period Format Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N1',
      Element: null,
      FriendlyName: 'Identification',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N1',
      Element: 1,
      FriendlyName: 'Entity Identifier Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N1',
      Element: 2,
      FriendlyName: 'Name',
      Semantics: '',
      Options: [
        { Value: '34', Description: 'Social Security Number' },
        { Value: '46', Description: 'ETIN Established by trading partner agreement' },
        { Value: 'BD', Description: 'Blue Cross Provider Number' },
        { Value: 'BS', Description: 'Blue Shield Provider Number' },
        { Value: 'FI', Description: "Federal Taxpayer's Identification Number" },
        { Value: 'HN', Description: 'Health Insurance Claim (HIC) Number' },
        {
          Value: 'II',
          Description: 'Standard Unique Health Indentifier for each individual in the United States'
        },
        { Value: 'MC', Description: 'Medicaid Provider Number' },
        { Value: 'MI', Description: 'Member Identification Number' },
        { Value: 'MR', Description: 'Medicaid Recipient Identification Number' },
        { Value: 'PC', Description: 'Provider Commercial Number' },
        { Value: 'PI', Description: 'Payer ID' },
        { Value: 'SL', Description: 'State License Number' },
        { Value: 'UP', Description: 'Unique Physician Identification Number (UPIN)' },
        { Value: 'XV', Description: 'Centers for Medicare and Medicaid Services PlanID' },
        {
          Value: 'XX',
          Description: 'Centers for Medicare and Medicaid Services National Provider Identifier'
        }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N1',
      Element: 3,
      FriendlyName: 'Identification Code Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N1',
      Element: 4,
      FriendlyName: 'Identification Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N1',
      Element: 5,
      FriendlyName: 'Entity Relationship Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N1',
      Element: 6,
      FriendlyName: 'Entity Identifier Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N3',
      Element: null,
      FriendlyName: 'Address',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N3',
      Element: 1,
      FriendlyName: 'Address Information',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N3',
      Element: 2,
      FriendlyName: 'Address Information',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N4',
      Element: null,
      FriendlyName: 'City, State, ZIP Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N4',
      Element: 1,
      FriendlyName: 'City Name',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N4',
      Element: 2,
      FriendlyName: 'State or Province Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N4',
      Element: 3,
      FriendlyName: 'Postal Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N4',
      Element: 4,
      FriendlyName: 'Country Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N4',
      Element: 5,
      FriendlyName: 'Location Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N4',
      Element: 6,
      FriendlyName: 'Location Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'N4',
      Element: 7,
      FriendlyName: 'Country Subdivision Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'RDM',
      Element: null,
      FriendlyName: 'Remittance Delivery Method',
      Semantics: '',
      Options: [
        { Value: 'BM', Description: 'By Mail' },
        { Value: 'EM', Description: 'E-Mail' },
        { Value: 'FT', Description: 'File Transfer' },
        { Value: 'OL', Description: 'On-Line' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'RDM',
      Element: 1,
      FriendlyName: 'Report Transmission Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'RDM',
      Element: 2,
      FriendlyName: 'Name',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'RDM',
      Element: 3,
      FriendlyName: 'Communication Number',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'RDM',
      Element: 4,
      FriendlyName: 'Reference Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'RDM',
      Element: 5,
      FriendlyName: 'Reference Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'LX',
      Element: null,
      FriendlyName: 'Header Number',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'LX',
      Element: 1,
      FriendlyName: 'Assigned Number',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: null,
      FriendlyName: 'Provider Summary Information',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 1,
      FriendlyName: 'Reference Identification',
      Semantics: 'Provider Number',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 2,
      FriendlyName: 'Facility Code Value',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 3,
      FriendlyName: 'Date',
      Semantics: "Last day of the provider's fiscal year",
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 4,
      FriendlyName: 'Quantity',
      Semantics: 'Total number of claims',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 5,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total of reported charges',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 6,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 7,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 8,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 9,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 10,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 11,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 12,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 13,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total Medicare Secondary Payer (MSP) primary payer amount',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 14,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 15,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Summary of non-lab charges',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 16,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 17,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Health Care Financing Administration Common Procedural Coding System (HCPCS) reported charges.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 18,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Total Health Care Financing Administration Common Procedural Coding System (HCPCS) payable amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 19,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 20,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total professional component amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 21,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total Medicare Secondary Payer (MSP) patient liability met.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 22,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total patient reimbursement.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 23,
      FriendlyName: 'Quantity',
      Semantics: 'Total periodic interim payment (PIP) number of claims.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS3',
      Element: 24,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: null,
      FriendlyName: 'Provider Supplemental Summary Information',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 1,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total diagnosis related group (DRG) amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 2,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total federal specific amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 3,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total hospital specific amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 4,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total disproportionate share amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 5,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total capital amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 6,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total indirect medical education amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 7,
      FriendlyName: 'Quantity',
      Semantics: 'Total number of outlier days.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 8,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total day outlier amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 9,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total cost outlier amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 10,
      FriendlyName: 'Quantity',
      Semantics: 'Diagnosis related group (DRG) average length of stay.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 11,
      FriendlyName: 'Quantity',
      Semantics: 'Total number of discharges.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 12,
      FriendlyName: 'Quantity',
      Semantics: 'Total number of cost report days.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 13,
      FriendlyName: 'Quantity',
      Semantics: 'Total number of covered days.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 14,
      FriendlyName: 'Quantity',
      Semantics: 'Total number of non-covered days.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 15,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Total Medicare Secondary Payer (MSP) pass-through amount calculated for a non-Medicare payer.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 16,
      FriendlyName: 'Quantity',
      Semantics: 'Average diagnosis related group (DRG) weight.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 17,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Total prospective payment system (PPS) capital, federal-specific portion, diagnosis related group (DRG) amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 18,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Total prospective payment system (PPS) capital, hospital-specific portion, diagnosis related group (DRG) amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'TS2',
      Element: 19,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Total prospective payment system (PPS) disproportionate share, hospital diagnosis related group (DRG) amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: null,
      FriendlyName: 'Claim Payment Information',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 1,
      FriendlyName: "Claim Submitter's Identifier",
      Semantics: '',
      Options: [
        { Value: '1', Description: 'Processed as Primary ' },
        { Value: '2', Description: 'Processed as Secondary ' },
        { Value: '3', Description: 'Processed as Tertiary ' },
        { Value: '4', Description: 'Denied ' },
        { Value: '19', Description: 'Processed as Primary, Forwarded to Additional Payer(s) ' },
        { Value: '20', Description: 'Processed as Secondary, Forwarded to Additional Payer(s) ' },
        { Value: '21', Description: 'Processed as Tertiary, Forwarded to Additional Payer(s) ' },
        { Value: '22', Description: 'Reversal of Previous Payment ' },
        { Value: '23', Description: 'Not Our Claim, Forwarded to Additional Payer(s) ' },
        { Value: '25', Description: 'Predetermination Pricing Only - No Payment ' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 2,
      FriendlyName: 'Claim Status Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 3,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 4,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 5,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: [
        { Value: '12', Description: 'Preferred Provider Organization (PPO)' },
        { Value: '13', Description: 'Point of service (POS)' },
        { Value: '14', Description: 'Exclusive Provider Organization (EPO)' },
        { Value: '15', Description: 'Indemnity Insurance' },
        { Value: '16', Description: 'Health Maintenance Organization (HMO) Medicare Risk' },
        { Value: '17', Description: 'Dental Maintenance Organization' },
        { Value: 'AM', Description: 'Automobile Medical' },
        { Value: 'CH', Description: 'Champus' },
        { Value: 'DS', Description: 'Disability' },
        { Value: 'HM', Description: 'Health Maintenance Organization' },
        { Value: 'LM', Description: 'Llability Medical' },
        { Value: 'MA', Description: 'Medicare Part A' },
        { Value: 'MB', Description: 'Medicare part B' },
        { Value: 'MC', Description: 'Medicaid' },
        { Value: 'OF', Description: 'Other Federal Program' },
        { Value: 'TV', Description: 'Title V' },
        { Value: 'VA', Description: 'Veterans Attalrs Plan' },
        { Value: 'WC', Description: 'Workers Compensation Health Claim' },
        { Value: 'ZZ', Description: 'Mutually Defined' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 6,
      FriendlyName: 'Claim Filing Indicator Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 7,
      FriendlyName: 'Reference Identification',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 8,
      FriendlyName: 'Facility Code Value',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 9,
      FriendlyName: 'Claim Frequency Type Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 10,
      FriendlyName: 'Patient Status Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 11,
      FriendlyName: 'Diagnosis Related Group (DRG) Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 12,
      FriendlyName: 'Quantity',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 13,
      FriendlyName: 'Percentage as Decimal',
      Semantics: '(0.0 to 1.0) Discharge fraction.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CLP',
      Element: 14,
      FriendlyName: 'Yes/No Condition or Response Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: null,
      FriendlyName: 'Claim Adjustment',
      Semantics: '',
      Options: [
        { Value: 'CO', Description: 'Contractual Obligations' },
        { Value: 'OA', Description: 'Other adjustments' },
        { Value: 'PI', Description: 'Payer Initiated Reductions' },
        { Value: 'PR', Description: 'Patient Responsibility' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 1,
      FriendlyName: 'Claim Adjustment Group Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 2,
      FriendlyName: 'Claim Adjustment Reason Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 3,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Amount of adjustment.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 4,
      FriendlyName: 'Quantity',
      Semantics: 'The units of service being adjusted.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 5,
      FriendlyName: 'Claim Adjustment Reason Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 6,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Amount of adjustment.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 7,
      FriendlyName: 'Quantity',
      Semantics: 'Units of service being adjusted.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 8,
      FriendlyName: 'Claim Adjustment Reason Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 9,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Amount of adjustment.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 10,
      FriendlyName: 'Quantity',
      Semantics: 'Units of service being adjusted.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 11,
      FriendlyName: 'Claim Adjustment Reason Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 12,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Amount of adjustment.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 13,
      FriendlyName: 'Quantity',
      Semantics: 'Units of service being adjusted.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 14,
      FriendlyName: 'Claim Adjustment Reason Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 15,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Amount of adjustment.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 16,
      FriendlyName: 'Quantity',
      Semantics: 'Units of service being adjusted.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 17,
      FriendlyName: 'Claim Adjustment Reason Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 18,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Amount of adjustment.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'CAS',
      Element: 19,
      FriendlyName: 'Quantity',
      Semantics: 'Units of service being adjusted.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: null,
      FriendlyName: 'Name Record',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 1,
      FriendlyName: 'Entity Identifier Code',
      Semantics: '',
      Options: [
        { Value: '1', Description: 'Person' },
        { Value: '2', Description: 'Non-Person Entity' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 2,
      FriendlyName: 'Entity Type Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 3,
      FriendlyName: 'Name Last or Organization Name',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 4,
      FriendlyName: 'Name First',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 5,
      FriendlyName: 'Name Middle',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 6,
      FriendlyName: 'Name Prefix',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 7,
      FriendlyName: 'Name Suffix',
      Semantics: '',
      Options: [
        { Value: '34', Description: 'Social Security Number' },
        { Value: '46', Description: 'ETIN Established by trading partner agreement' },
        { Value: 'BD', Description: 'Blue Cross Provider Number' },
        { Value: 'BS', Description: 'Blue Shield Provider Number' },
        { Value: 'FI', Description: "Federal Taxpayer's Identification Number" },
        { Value: 'HN', Description: 'Health Insurance Claim (HIC) Number' },
        {
          Value: 'II',
          Description: 'Standard Unique Health Indentifier for each individual in the United States'
        },
        { Value: 'MC', Description: 'Medicaid Provider Number' },
        { Value: 'MI', Description: 'Member Identification Number' },
        { Value: 'MR', Description: 'Medicaid Recipient Identification Number' },
        { Value: 'PC', Description: 'Provider Commercial Number' },
        { Value: 'PI', Description: 'Payer ID' },
        { Value: 'SL', Description: 'State License Number' },
        { Value: 'UP', Description: 'Unique Physician Identification Number (UPIN)' },
        { Value: 'XV', Description: 'Centers for Medicare and Medicaid Services PlanID' },
        {
          Value: 'XX',
          Description: 'Centers for Medicare and Medicaid Services National Provider Identifier'
        }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 8,
      FriendlyName: 'Identification Code Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 9,
      FriendlyName: 'Identification Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 10,
      FriendlyName: 'Entity Relationship Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 11,
      FriendlyName: 'Entity Identifier Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NM1',
      Element: 12,
      FriendlyName: 'Name Last or Organization Name',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: null,
      FriendlyName: 'Inpatient Adjudication Information',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 1,
      FriendlyName: 'Quantity',
      Semantics: 'Covered Days',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 2,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Prospective Payment System (PPS) Operating Outlier amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 3,
      FriendlyName: 'Quantity',
      Semantics: 'Lifetime psychiatric days.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 4,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Diagnosis related group (DRG) amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 5,
      FriendlyName: 'Reference Identification',
      Semantics: 'Claim Payment Remark Code.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 6,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Disproportionate share amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 7,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Medicare Secondary Payer (MSP) pass-through amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 8,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Total Prospective Payment System (PPS) capital amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 9,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Prospective Payment System (PPS) capital, federal specific portion, Diagnosis Related Group (DRG) amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 10,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Prospective Payment System (PPS) capital, hospital specific portion, Diagnosis Related Group (DRG) amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 11,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Prospective Payment System (PPS) capital, disproportionate share, hospital Diagnosis Related Group (DRG) amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 12,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Old Capital amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 13,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Prospective Payment System (PPS) capital indirect medical education claim amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 14,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Hospital specific Diagnosis Related Group (DRG) Amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 15,
      FriendlyName: 'Quantity',
      Semantics: 'Cost report days.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 16,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Federal specific Diagnosis Related Group (DRG) amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 17,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Prospective Payment System (PPS) Capital Outlier amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 18,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Indirect teaching amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 19,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Professional component amount billed but not payable.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 20,
      FriendlyName: 'Reference Identification',
      Semantics: 'Claim Payment Remark Code.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 21,
      FriendlyName: 'Reference Identification',
      Semantics: 'Claim Payment Remark Code.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 22,
      FriendlyName: 'Reference Identification',
      Semantics: 'Claim Payment Remark Code.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 23,
      FriendlyName: 'Reference Identification',
      Semantics: 'Claim Payment Remark Code.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MIA',
      Element: 24,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Capital exception amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MOA',
      Element: null,
      FriendlyName: 'Outpatient Adjudication Information',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MOA',
      Element: 1,
      FriendlyName: 'Percentage as Decimal',
      Semantics: 'Reimbursement rate.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MOA',
      Element: 2,
      FriendlyName: 'Monetary Amount',
      Semantics:
        'Claim Health Care Financing Administration Common Procedural Coding System (HCPCS) payable amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MOA',
      Element: 3,
      FriendlyName: 'Reference Identification',
      Semantics: 'Claim Payment Remark Code.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MOA',
      Element: 4,
      FriendlyName: 'Reference Identification',
      Semantics: 'Claim Payment Remark Code.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MOA',
      Element: 5,
      FriendlyName: 'Reference Identification',
      Semantics: 'Claim Payment Remark Code.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MOA',
      Element: 6,
      FriendlyName: 'Reference Identification',
      Semantics: 'Claim Payment Remark Code.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MOA',
      Element: 7,
      FriendlyName: 'Reference Identification',
      Semantics: 'Claim Payment Remark Code.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MOA',
      Element: 8,
      FriendlyName: 'Monetary Amount',
      Semantics: 'End Stage Renal Disease (ESRD) payment amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'MOA',
      Element: 9,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Professional component amount billed but not payable.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PER',
      Element: null,
      FriendlyName: 'Claim Contact Information',
      Semantics: '',
      Options: [{ Value: '366', Description: 'Payers Claim Office' }]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PER',
      Element: 1,
      FriendlyName: 'Contact Function Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PER',
      Element: 2,
      FriendlyName: 'Name',
      Semantics: '',
      Options: [
        { Value: 'EM', Description: 'Electronic Mail' },
        { Value: 'FX', Description: 'Facsimile' },
        { Value: 'TE', Description: 'Telephone' },
        { Value: 'TEX', Description: 'Telephone Extension' },
        { Value: 'UR', Description: 'Uniform Resource Locator (URL)' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PER',
      Element: 3,
      FriendlyName: 'Communication Number Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PER',
      Element: 4,
      FriendlyName: 'Communication Number',
      Semantics: '',
      Options: [
        { Value: 'EM', Description: 'Electronic Mail' },
        { Value: 'FX', Description: 'Facsimile' },
        { Value: 'TE', Description: 'Telephone' },
        { Value: 'TEX', Description: 'Telephone Extension' },
        { Value: 'UR', Description: 'Uniform Resource Locator (URL)' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PER',
      Element: 5,
      FriendlyName: 'Communication Number Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PER',
      Element: 6,
      FriendlyName: 'Communication Number',
      Semantics: '',
      Options: [
        { Value: 'EM', Description: 'Electronic Mail' },
        { Value: 'FX', Description: 'Facsimile' },
        { Value: 'TE', Description: 'Telephone' },
        { Value: 'TEX', Description: 'Telephone Extension' },
        { Value: 'UR', Description: 'Uniform Resource Locator (URL)' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PER',
      Element: 7,
      FriendlyName: 'Communication Number Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PER',
      Element: 8,
      FriendlyName: 'Communication Number',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PER',
      Element: 9,
      FriendlyName: 'Contact Inquiry Reference',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'AMT',
      Element: null,
      FriendlyName: 'Claim Supplemental Information',
      Semantics: '',
      Options: [
        { Value: 'AU', Description: 'Coverage Amount' },
        { Value: 'D8', Description: 'Discount Amount' },
        { Value: 'DY', Description: 'Per Day Limit' },
        { Value: 'F5', Description: 'Patient Amount Paid' },
        { Value: 'I', Description: 'Interest' },
        { Value: 'NL', Description: 'Negative Ledger Balance' },
        { Value: 'T', Description: 'Tax' },
        { Value: 'T2', Description: 'Total Claim Before Taxes' },
        { Value: 'ZK', Description: 'Federal Medicare or Medicaid Payment Mandate - Category I' },
        { Value: 'ZL', Description: 'Federal Medicare or Medicaid Payment Mandate - Category 2' },
        { Value: 'ZM', Description: 'Federal Medicare or Medicaid Payment Mandate - Category 3' },
        { Value: 'ZN', Description: 'Federal Medicare or Medicaid Payment Mandate - Category 4' },
        { Value: 'ZO', Description: 'Federal Medicare or Medicaid Payment Mandate - Category 5' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'AMT',
      Element: 1,
      FriendlyName: 'Amount Qualifier Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'AMT',
      Element: 2,
      FriendlyName: 'Monetary Amount',
      Semantics: '',
      Options: [
        { Value: 'C', Description: 'Credit' },
        { Value: 'D', Description: 'Debit' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'AMT',
      Element: 3,
      FriendlyName: 'Credit/Debit Flag Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'QTY',
      Element: null,
      FriendlyName: 'Claim Supplemental Information Quantity',
      Semantics: '',
      Options: [
        { Value: 'CA', Description: 'Covered - Actual' },
        { Value: 'CD', Description: 'Co-insured - Actual' },
        { Value: 'LA', Description: 'Life-time Reserve - Actual' },
        { Value: 'LE', Description: 'Life-time Reserve - Estimated' },
        { Value: 'NE', Description: 'Non-covered - Estimated' },
        { Value: 'NR', Description: 'Not Replaced Blood units' },
        { Value: 'OU', Description: 'Outlier Days' },
        { Value: 'PS', Description: 'Prescription' },
        { Value: 'VS', Description: 'Visits' },
        { Value: 'ZK', Description: 'Federal Medicare or Medicaid Payment Mandate - Category I' },
        { Value: 'ZL', Description: 'Federal Medicare or Medicaid Payment Mandate - Category 2' },
        { Value: 'ZM', Description: 'Federal Medicare or Medicaid Payment Mandate - Category 3' },
        { Value: 'ZN', Description: 'Federal Medicare or Medicaid Payment Mandate - Category 4' },
        { Value: 'ZO', Description: 'Federal Medicare or Medicaid Payment Mandate - Category 5' }
      ]
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'QTY',
      Element: 1,
      FriendlyName: 'Quantity Qualifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'QTY',
      Element: 2,
      FriendlyName: 'Quantity',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'QTY',
      Element: 3,
      FriendlyName: 'Composite Unit of Measure',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'QTY',
      Element: 4,
      FriendlyName: 'Free-form information',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SVC',
      Element: null,
      FriendlyName: 'Service Payment Information',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SVC',
      Element: 1,
      FriendlyName: 'Composite Medical Procedure Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SVC',
      Element: 2,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Submitted Service Charge',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SVC',
      Element: 3,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Amount paid this service.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SVC',
      Element: 4,
      FriendlyName: 'Product/Service ID',
      Semantics: 'National Uniform Billing Committee Revenue Code',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SVC',
      Element: 5,
      FriendlyName: 'Quantity',
      Semantics: 'Paid units of service.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SVC',
      Element: 6,
      FriendlyName: 'Composite Medical Procedure Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SVC',
      Element: 7,
      FriendlyName: 'Quantity',
      Semantics: 'Original submitted units of service.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'LQ',
      Element: null,
      FriendlyName: 'Health Care Remark Codes',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'LQ',
      Element: 1,
      FriendlyName: 'Code List Qualifier Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'LQ',
      Element: 2,
      FriendlyName: 'Industry Code',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: null,
      FriendlyName: 'Provider Adjustment',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 1,
      FriendlyName: 'Reference Identification',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 2,
      FriendlyName: 'Date',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 3,
      FriendlyName: 'Adjustment Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 4,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Adjustment amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 5,
      FriendlyName: 'Adjustment Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 6,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Adjustment amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 7,
      FriendlyName: 'Adjustment Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 8,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Adjustment amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 9,
      FriendlyName: 'Adjustment Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 10,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Adjustment amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 11,
      FriendlyName: 'Adjustment Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 12,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Adjustment amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 13,
      FriendlyName: 'Adjustment Identifier',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'PLB',
      Element: 14,
      FriendlyName: 'Monetary Amount',
      Semantics: 'Adjustment amount.',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SE',
      Element: null,
      FriendlyName: 'Transaction Set Trailer',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SE',
      Element: 1,
      FriendlyName: 'Number of Included Segments',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'SE',
      Element: 2,
      FriendlyName: 'Transaction Set Control Number',
      Semantics: '',
      Options: null
    } as IX12Helper,
    {
      FileType: '835',
      Segment: 'NTE',
      Element: 1,
      FriendlyName: 'Note',
      Options: null
    } as IX12Helper
  ]

  public static x12: IX12Helper[] = [].concat(X12Codes.x12_837, X12Codes.x12_835)

  public static Find(
    FileType: string,
    SegmentId: string,
    ElementId: number,
    Value: string
  ): IX12Helper {
    const candidate = _.cloneDeep(
      this.x12.find(
        x => x.FileType === FileType && x.Segment === SegmentId && x.Element === ElementId
      )
    )

    if (candidate) {
      candidate.ToolTip = candidate.Semantics || ''

      if (candidate.Options) {
        const opts = candidate.Options.map(x => `${x.Value} - ${x.Description}`).join('\r\n')
        const match = candidate.Options.find(x => x.Value === Value)
        if (match) {
          candidate.FriendlyName = `${candidate.FriendlyName} (${match.Description})`
        }

        if (opts.length > 0) {
          candidate.ToolTip = candidate.ToolTip + '\r\n\r\n' + opts
        }
      }
    }

    return candidate
  }

  public static SegmentNames(): string[] {
    return Array.from(new Set(this.x12.map(x => x.Segment)))
  }

  public static FormatValue(value: string, definition: IX12Helper) {
    let result = null

    if (definition && definition.DisplayAs) {
      switch (definition.DisplayAs) {
        case 'date':
          const parsed = moment(value, definition.InputFormat)

          if (parsed.isValid()) {
            result = parsed.format('MM/DD/YYYY')
          }
          break
      }
    }

    if (!result) {
      result = value
    }

    return result
  }
}
